import "./PFDTostacionPage.css";
import SvgPdfTostacion from "../../components/svg-pfd-tostacion/SvgPfdTostacion";
import { useState, useEffect } from "react";
import { PFDFetching } from "../../class/fetchPfdTostacion";
import { getValoresPeriodo } from "../../services/services";
import { Loader } from "@scuf/common";

/**
 * Retorna la página de PDF Tostacion
 * @returns
 */
export default function PDFTostacionPage() {
  const [loading, setLoading] = useState(true);
  const [arrData, setArrData] = useState();

  // Peticion que nos trae todo los valores generales de las corrientes, esto es para la primera carga
  const globalValues = new PFDFetching()
    .setIdSeccion(7)
    .setSecuencia(0)
    .setUltimo(1)
    .setOrden(1);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(globalValues);
      const arrData = data
        .filter((x) => x.Secuencia >= 1 && x.Secuencia <= 17)
        .map((item) => {
          return {
            secuencia: item.Secuencia,
            valor: item.Valor,
            unit: item.UOM,
            estado: item.Estado,
          };
        });

      setArrData(arrData);

      setLoading(false);
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <section className="PFD-tostacion-page">
        <div className="container-pfd">
          {loading ? (
            <Loader minHeight={400} text="Cargando"></Loader>
          ) : (
            <SvgPdfTostacion data={arrData} />
          )}
        </div>
      </section>
    </>
  );
}
